import { Raw } from "@easy-email-pro-core/components";
import {
  EmailRenderProvider,
  useEmailRenderContext,
} from "@easy-email-pro-core/utils/EditorCore/contexts/EmailRenderContext";
import React from "react";

export interface ResponsiveElementProps {
  desktop: React.FC<{ children?: React.ReactElement }>;
  mobile: React.FC<{ children?: React.ReactElement }>;
}

export function ResponsiveElement(props: ResponsiveElementProps) {
  const { desktop: Desktop, mobile: Mobile } = props;
  const context = useEmailRenderContext();
  const { displayMode = "desktop-mobile" } = context;

  if (displayMode === "only-desktop") {
    return (
      <EmailRenderProvider {...context} displayMode={"only-desktop"}>
        <>
          <Desktop />
        </>
      </EmailRenderProvider>
    );
  }

  if (displayMode === "only-mobile") {
    return (
      <>
        {/* only visible in mobile */}
        {context.mode === "production" && (
          <Raw>{`<!-- htmlmin:ignore --><!--[if !mso]><!--><!-- htmlmin:ignore -->`}</Raw>
        )}
        <EmailRenderProvider {...context} displayMode={"only-mobile"}>
          <>
            <Mobile />
          </>
        </EmailRenderProvider>
        {context.mode === "production" && (
          <Raw>{`<!-- htmlmin:ignore --><!--<![endif]--><!-- htmlmin:ignore -->`}</Raw>
        )}
      </>
    );
  }
  return (
    <>
      {/* only visible in desktop */}
      <EmailRenderProvider {...context} displayMode={"only-desktop"}>
        <>
          <Desktop />
        </>
      </EmailRenderProvider>

      {/* only visible in mobile */}
      {context.mode === "production" && (
        <Raw>{`<!-- htmlmin:ignore --><!--[if !mso]><!--><!-- htmlmin:ignore -->`}</Raw>
      )}
      <EmailRenderProvider {...context} displayMode={"only-mobile"}>
        <>
          <Mobile />
        </>
      </EmailRenderProvider>
      {context.mode === "production" && (
        <Raw>{`<!-- htmlmin:ignore --><!--<![endif]--><!-- htmlmin:ignore -->`}</Raw>
      )}
    </>
  );
}
